export function excludeMask(value: string) {
  return value.replaceAll(' ', '').replaceAll('-', '').replaceAll('_', '');
}
